import { render } from "./Folders.vue?vue&type=template&id=b9ca7b42"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"

import "./Folders.vue?vue&type=style&index=0&id=b9ca7b42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__